var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-box"},[_vm._l((_vm.data),function(value,key){return _c('WrapperField',{key:value + key,attrs:{"data":_vm.createDataField({
        fieldName: key,
        fieldValue: value,
        fieldGroup: _vm.FieldGroup.ACCEPTANCE_DEPOSIT_DETAILS,
      })}})}),(_vm.data.obligationDocument)?[_c('TitleField',{attrs:{"fieldName":_vm.FieldName.obligationDocument.IS_OBLIGATION_DOCUMENT,"fieldGroup":_vm.FieldGroup.OBLIGATION_DOCUMENT}}),_vm._l((_vm.data.obligationDocument),function(value,key){return _c('WrapperField',{key:value + key,attrs:{"data":_vm.createDataField({
          fieldName: key,
          fieldValue: value,
          fieldGroup: _vm.FieldGroup.OBLIGATION_DOCUMENT,
        })}})})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }